/**
 * Formatter: Currency & Number
 */
export const FormatNumber = (value: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'decimal'
  }).format(value)

export const FormatCurrency = (currency: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currencyDisplay: 'USD'
  }).format(currency)
